import { useCallback } from 'react'
import {
  deleteEngageDefaultSettings,
  getEngageDefaultSettings,
  postEngageDefaultSettings,
  putEngageDefaultSettings,
} from '../crud/orgs.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = []

const useEngageDefaultSettings = () => {
  const parseData = useCallback((data) => data ?? [], [])

  const getControls = useApiControls({ api: getEngageDefaultSettings, parseData, initialData: INITIAL_DATA }) // loading, error, success, data, callApi

  const postControls = useApiControls({ api: postEngageDefaultSettings })

  const putControls = useApiControls({ api: putEngageDefaultSettings })

  const deleteControls = useApiControls({ api: deleteEngageDefaultSettings })

  // reset states (loading, error, success, ...) for POST, PUT and GET
  // the states for these methods are usually needed for the moment of operation only and don't need to be maintained after the form modal is closed for instance
  const resetPost = postControls.reset
  const resetPut = putControls.reset
  const resetDelete = deleteControls.reset
  const resetEngageDefaultSettingsControls = useCallback(() => {
    resetPost()
    resetPut()
    resetDelete()
  }, [resetPost, resetPut, resetDelete])

  return {
    // get
    fetchEngageDefaultSettings: getControls.callApi,
    isFetchingEngageDefaultSettings: getControls.loading,
    errorFetchingEngageDefaultSettings: getControls.error,
    engageDefaultSettings: getControls.data,

    // post
    createEngageDefaultSettings: postControls.callApi,
    isCreatingEngageDefaultSettings: postControls.loading,
    errorCreatingEngageDefaultSettings: postControls.error,
    successCreatingEngageDefaultSettings: postControls.success,

    // put
    updateEngageDefaultSettings: putControls.callApi,
    isUpdatingEngageDefaultSettings: putControls.loading,
    errorUpdatingEngageDefaultSettings: putControls.error,
    successUpdatingEngageDefaultSettings: putControls.success,

    // delete
    deleteEngageDefaultSettings: deleteControls.callApi,
    isDeletingEngageDefaultSettings: deleteControls.loading,
    errorDeletingEngageDefaultSettings: deleteControls.error,

    // reset
    resetEngageDefaultSettingsControls,
  }
}

export default useEngageDefaultSettings
